__turbopack_context__.v({
  "button": "_7VqGtG_button",
  "buttons": "_7VqGtG_buttons",
  "content": "_7VqGtG_content",
  "description": "_7VqGtG_description",
  "header": "_7VqGtG_header",
  "popup": "_7VqGtG_popup",
  "subDescription": "_7VqGtG_subDescription",
  "title": "_7VqGtG_title",
});
